// extracted by mini-css-extract-plugin
export default {"tab":"fileTabButton_tab__1kO9W","active":"fileTabButton_active__6bimH","indicator-new":"fileTabButton_indicator-new__pBtCX"};